<template>
  <div class="loading">
    <div class="loading__bars">
      <div class="rect1"></div>
      <div class="rect2"></div>
      <div class="rect3"></div>
      <div class="rect4"></div>
      <div class="rect5"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'loading'
  }
</script>

<style scoped lang="postcss">
.loading {
  text-align: center;
  height: calc(100% - 157px);
  display: flex;
  background-color: rgba(255, 255, 255, 0.4)
}

.loading__bars > div {
  background-color: #004435;
  height: 100%;
  width: 6px;
  display: inline-block;

  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.loading__bars {
  margin: auto;
  width: 50px;
  height: 40px;
  text-align: center;
  font-size: 10px;

  .rect2 {
    animation-delay: -1.1s;
  }

  .rect3 {
    animation-delay: -1.0s;
  }

  .rect4 {
    animation-delay: -0.9s;
  }

  .rect5 {
    animation-delay: -0.8s;
  }
}

@keyframes sk-stretchdelay {
  0%, 40%, 100% {
    transform: scaleY(0.4);
  }  20% {
    transform: scaleY(1.0);
  }
}
</style>
